import React from 'react';

/**
 * DEO Logo — kullanıcı tarafından sağlanan finalize logo (PNG).
 *
 * `orientation`: 'vertical' (default, square key form) | 'horizontal' (with text beside key)
 * `tone`:
 *   - 'espresso' (varsayılan, açık zeminlerde okunaklı koyu kahve)
 *   - 'copper'   (orta — bakır vurgu)
 *   - 'copper-bright' (turuncu — koyu zeminde sıcak vurgu)
 *   - 'bone'     (krem — koyu zeminde)
 *   - 'bronze'   (gri-bronz gradient — hero showcase, premium)
 *   - 'black'    (saf siyah, orijinal)
 */
export default function DeoLogo({
  size = 80,
  tone = 'espresso',
  orientation = 'vertical',
  variant,
  className = '',
  style = {},
}) {
  const effectiveTone = tone || (variant === 'black' ? 'espresso' : 'espresso');

  const verticalMap = {
    espresso: '/assets/brand/deo_logo_espresso.png',
    copper: '/assets/brand/deo_logo_copper_deep.png',
    'copper-bright': '/assets/brand/deo_logo_copper_bright.png',
    bone: '/assets/brand/deo_logo_bone.png',
    bronze: '/assets/brand/deo_logo_bronze.png',
    black: '/assets/brand/deo_logo_color.png',
  };
  const horizontalMap = {
    espresso: '/assets/brand/deo_logo_horizontal_espresso.png',
    bone: '/assets/brand/deo_logo_horizontal_bone.png',
    black: '/assets/brand/deo_logo_horizontal.png',
  };

  const srcMap = orientation === 'horizontal' ? horizontalMap : verticalMap;
  const src = srcMap[effectiveTone] || srcMap.espresso;

  return (
    <img
      src={src}
      alt="DEO · Dijital Emlak Ofisi"
      className={className}
      style={{
        height: `${size}px`,
        width: 'auto',
        objectFit: 'contain',
        ...style,
      }}
      draggable={false}
    />
  );
}
